import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import dayjs from 'dayjs'
import { ContentGuide } from 'global/guides/ContentGuide'
import Dialog from 'global/guides/Dialog'
import { useValeAlimentacaoOutletContext } from 'pages/RelatorioValeAlimentacao'
import { useParams } from 'react-router-dom'
import { funcionario } from 'service/api'
import AlterarPagamento from './AlterarPagamento'

export default function DetalhesValeAlimentacao() {
    const { funcionarioId } = useParams()
    const { data } = useValeAlimentacaoOutletContext()

    const { data: func } = funcionario.useFetchById(+funcionarioId!)
    const nomeFuncionario = func?.nome

    return (
        <Dialog.Root width="auto">
            <Dialog.Title>{nomeFuncionario}</Dialog.Title>
            <Dialog.Content
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                }}
                dividers
            >
                <ContentGuide.DataGrid
                    loading={false}
                    rows={data?.filter(
                        d => d.funcionarioId === +funcionarioId!,
                    )}
                    columns={[
                        {
                            field: 'data',
                            headerName: 'Data',
                            minWidth: 130,
                            flex: 0.8,
                            type: 'date',
                            valueFormatter: ({ value }) =>
                                value
                                    ? dayjs.utc(value).format('DD/MM/YYYY')
                                    : '',
                        },
                        {
                            field: 'horasTrabalhadas',
                            headerName: 'Horas trabalhadas',
                            width: 180,
                            headerAlign: 'right',
                            align: 'right',
                        },
                        {
                            field: 'porcentagem',
                            headerName: 'Porcentagem a receber',
                            width: 180,
                            align: 'right',
                            valueFormatter: ({ value }) => `${value}%`,
                        },
                        {
                            field: 'bonus',
                            headerName: 'Bonus',
                            width: 80,
                            align: 'right',
                            valueFormatter: ({ value }) => `${value}%`,
                        },
                        {
                            field: 'valorTotal',
                            headerName: 'Valor total',
                            align: 'center',
                            width: 100,
                            valueFormatter: ({ value }) =>
                                `R$ ${value
                                    .toFixed(2)
                                    .toString()
                                    .replace('.', ',')}`,
                        },
                        {
                            ...optionsColumn,
                            disableExport: false,
                            field: 'pagar',
                            headerName: 'Pagar',
                            type: 'boolean',
                            renderCell: AlterarPagamento,
                        },
                    ]}
                    density="compact"
                    hideFooter
                    ToolbarProps={{ hideToolbar: true }}
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
